import _slicedToArray from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/esnext.iterator.map.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/logo128.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-14d50ecd"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "h-carousel"
};
var _hoisted_2 = {
  class: "wrapper"
};
var _hoisted_3 = {
  class: "home-r-box"
};
var _hoisted_4 = {
  class: "header"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-duoyuyan"
  }, null, -1);
});
var _hoisted_6 = {
  class: "center"
};
var _hoisted_7 = {
  class: "logo",
  id: "passport-login-logo"
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    src: _imports_0,
    alt: ""
  }, null, -1);
});
var _hoisted_9 = {
  class: "content"
};
var _hoisted_10 = {
  class: "footer",
  id: "passport-login-footer"
};
var _hoisted_11 = {
  class: "left"
};
var _hoisted_12 = {
  key: 0,
  target: "_blank",
  href: "https://beian.miit.gov.cn/",
  rel: "noopener"
};
var _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"footer-center\" data-v-14d50ecd><div class=\"ISO1\" data-v-14d50ecd></div><div class=\"ISO2\" data-v-14d50ecd></div><div class=\"ISO3\" data-v-14d50ecd></div><div class=\"ISO4\" data-v-14d50ecd></div></div>", 1);
var _hoisted_14 = {
  key: 0,
  class: "right"
};
import contactUs from '@/components/contact/index.vue';
import langWrapper from '@/components/pub/lang.vue';
import { useLang } from '@/hooks/lang';
import { XlCarousel } from '@shining3d/ui-components';
import _get from 'lodash/get';
import { VueCookieNext } from 'vue-cookie-next';
import { useStore } from 'vuex';
import { SOFTWAREFLAG } from '@/utils/config';
export default {
  setup: function setup(__props) {
    var store = useStore();
    var _useLang = useLang(),
      $t = _useLang.$t;

    // 判断是否为tx3，并作页面定制化
    var customized = ref({
      hasBanner: true,
      hasLang: true,
      hasRecommendedUse: true
    });
    var loginType = ref('');
    if (sessionStorage.getItem(SOFTWAREFLAG)) {
      var _sessionStorage$getIt = sessionStorage.getItem(SOFTWAREFLAG).split('_'),
        _sessionStorage$getIt2 = _slicedToArray(_sessionStorage$getIt, 1),
        soft = _sessionStorage$getIt2[0];
      loginType.value = 'SOFT';
      store.commit('setThemeColor', soft + ' SOFTWARE');
      customized.value = {
        hasBanner: false,
        hasLang: false,
        hasRecommendedUse: false
      };
    }
    var contactUsRef = ref(null);
    var curNode = ref('zh-cn');
    var cc = ref(VueCookieNext.getCookie('cc'));
    curNode.value = VueCookieNext.getCookie('lang');
    var banners = computed(function () {
      var list = _get(store, 'state.global.loginBanner');
      return list.map(function (item) {
        return typeof item === 'string' ? {
          link: '',
          imgSrc: item
        } : item;
      });
    });
    var contentProviderText = _get(store, 'state.global.InternetContentProvider');

    // 联系我们
    var contactUsChange = function contactUsChange() {
      contactUsRef.value.getInfo();
      contactUsRef.value.dialogVisible = true;
    };
    function readAgreement(params) {
      switch (params) {
        case 'privacyPolicy':
          store.commit('setPrivacyPolicy');
          break;
        case 'termsOfUse':
          store.commit('setTermsOfUse');
          break;
        default:
          break;
      }
    }
    var homeLWidth = ref('40%');
    function setHomeLWidth() {
      var wH = window.innerHeight;
      homeLWidth.value = Math.floor(wH * 580 / 900) + 'px';
    }
    onMounted(function () {
      setHomeLWidth();
      // 监听页面改变
      window.addEventListener('resize', setHomeLWidth);
    });
    onUnmounted(function () {
      window.removeEventListener('resize', setHomeLWidth);
    });
    return function (_ctx, _cache) {
      var _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["user-page", [loginType.value]])
      }, [customized.value.hasBanner ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "home-l",
        style: _normalizeStyle({
          width: homeLWidth.value
        })
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(XlCarousel), {
        imgList: _unref(banners)
      }, null, 8, ["imgList"])])], 4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [customized.value.hasLang ? (_openBlock(), _createBlock(langWrapper, {
        key: 0,
        class: "lang-option"
      }, {
        default: _withCtx(function () {
          return [_hoisted_5];
        }),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", null, _toDisplayString(_unref($t)("home.passportTitle")), 1)]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_router_view)])])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [cc.value === 'CN' ? (_openBlock(), _createElementBlock("a", _hoisted_12, _toDisplayString(_unref(contentProviderText)), 1)) : _createCommentVNode("", true), _createElementVNode("span", {
        class: "contact",
        onClick: contactUsChange
      }, _toDisplayString(_unref($t)("app-login.contactUs")), 1), _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return readAgreement('privacyPolicy');
        })
      }, _toDisplayString(_unref($t)("app-login.privacyPolicy")), 1), _createElementVNode("span", {
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return readAgreement('termsOfUse');
        })
      }, _toDisplayString(_unref($t)("app-login.termsOfUse")), 1)]), _hoisted_13, customized.value.hasRecommendedUse ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref($t)("app-login.recommendedUse")), 1)) : _createCommentVNode("", true)])]), _createVNode(contactUs, {
        ref_key: "contactUsRef",
        ref: contactUsRef
      }, null, 512)], 2);
    };
  }
};